module.exports = __webpack_public_path__ + "static/media/FzefidxaQAE4lbA.e5bc93bc.webp";